import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "rec-media-player" };
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { class: "rec-media-player__audio__tooltip rec-media-player__audio__tooltip--cursor" };
const _hoisted_6 = { class: "rec-media-player__audio__tooltip rec-media-player__audio__tooltip--mouse" };
import { useDateTimeFormat } from "@/common/composables/date-time-format";
import { useWaveform } from "../composables/waveform";
import { useElementBounding, useVModel } from "@vueuse/core";
import { computed, nextTick, onMounted, ref, watch } from "vue";
import { MediaSource } from "../types";
export default /*@__PURE__*/ _defineComponent({
    __name: 'MediaPlayer',
    props: {
        isPlaying: { type: Boolean },
        currentTime: {},
        segmentRecordings: {},
        mobile: { type: Boolean },
        type: {},
        mimeType: {},
        mediaId: {}
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "v4f5ee3e8": (wavehoverPointer.value),
            "v75c859b2": (waveMousePosition.value),
            "v70441386": (waveCursorPosition.value)
        }));
        const props = __props;
        const isPlayingVModel = useVModel(props, "isPlaying");
        const displayTime = useVModel(props, "currentTime");
        const dateFormat = useDateTimeFormat();
        const waveColor = getComputedStyle(document.documentElement).getPropertyValue("--p-d-80");
        const waveform = ref();
        const { width: waveWidth } = useElementBounding(waveform);
        const waveRefs = ref([]);
        const waveformConfig = ref({
            progressColor: "#fff",
            waveColor: waveColor,
            barWidth: 1,
            barRadius: 2,
            cursorWidth: 0,
            height: 30,
            barHeight: 3,
            barMinHeight: 1,
            interact: false,
            barGap: 2,
            responsive: true
        });
        const audioRefs = ref([]);
        const { waveformPlayerPlay } = useWaveform(waveformConfig, displayTime);
        const currentTimeRef = ref(0);
        const currentAudioSegment = computed(() => props.segmentRecordings.filter((s) => currentTimeRef.value >= s.offset).length - 1);
        const currentAudioRef = computed(() => audioRefs.value[currentAudioSegment.value]);
        const currentOffset = computed(() => props.segmentRecordings[currentAudioSegment.value].offset);
        const mousePosX = ref(0);
        const displayTimeFormatted = computed(() => dateFormat.timerFormat(displayTime.value));
        const waveMouseTimeFormatted = computed(() => dateFormat.timerFormat(waveMouseTime.value));
        // Doens't like v-if="waveWidth" on v-for - we don't want the elements rendered until the width is known
        const recordings = computed(() => (waveWidth.value > 0 ? props.segmentRecordings : []));
        const waveMouseTime = computed(() => {
            if (!waveform.value)
                return 0;
            return ((duration.value * (mousePosX.value - waveform.value.getBoundingClientRect().left)) /
                (waveform.value.getBoundingClientRect().right - waveform.value.getBoundingClientRect().left));
        });
        const waveMousePosition = computed(() => {
            if (!waveform.value)
                return "0px";
            return mousePosX.value - waveform.value.getBoundingClientRect().left + "px";
        });
        const waveCursorPosition = computed(() => {
            if (!waveform.value || !waveWidth.value || duration.value == 0)
                return "0px";
            return (displayTime.value / duration.value) * waveWidth.value + "px";
        });
        onMounted(async () => {
            for (let i = 0; i < props.segmentRecordings.length; i++) {
                if (!props.segmentRecordings[i].url) {
                    await getUrl(props.segmentRecordings[i]);
                }
            }
            // if ( props.type == 'audio' ) {
            nextTick(() => {
                props.segmentRecordings.forEach((r, idx) => {
                    waveformPlayerPlay(waveRefs.value[idx], r.offset, r.duration, r.url ?? "#");
                });
            });
            // }
            initAudio();
            document.addEventListener("mousemove", (event) => {
                mousePosX.value = event.clientX;
            });
        });
        const waveClick = (e) => {
            if (!validDuration.value || !waveWidth.value)
                return;
            const pos = e.clientX - waveform.value.getBoundingClientRect().left;
            const ratio = pos / waveWidth.value;
            playFrom(ratio * duration.value);
        };
        watch(() => audioRefs, () => initAudio(), { deep: true });
        const validDuration = ref();
        const initAudio = () => {
            audioRefs.value.forEach((a, index) => {
                let errorCount = 0;
                a.pause();
                a.ontimeupdate = () => {
                    timeupdate(a, index);
                };
                a.onplay = () => {
                    errorCount = 0;
                };
                a.onended = () => {
                    playSegment(index + 1);
                };
                a.onabort = (_e) => {
                    // console.log(`ABORT ${index}`);
                };
                a.oncanplaythrough = (_e) => {
                    if (a.duration == Infinity) {
                        validDuration.value = false;
                        waveformConfig.value.interact = false;
                    }
                    else if (validDuration.value != false) {
                        validDuration.value = true;
                        waveformConfig.value.interact = true;
                    }
                };
                a.onerror = (_e, _e2) => {
                    if (errorCount++ < 10) {
                        console.log(a.error);
                        const _time = a.currentTime;
                        const src = a.src;
                        a.pause();
                        a.src = src;
                        a.currentTime = 0;
                        if (isPlayingVModel.value) {
                            a.play();
                        }
                    }
                    //getUrl(props.segmentRecordings[index]);
                };
            });
        };
        watch(currentAudioRef, (_curr, last) => {
            last?.pause();
            syncAudioRef();
        });
        const syncAudioRef = () => {
            if (!currentAudioRef.value)
                return;
            currentAudioRef.value.currentTime = currentTimeRef.value - currentOffset.value;
            if (isPlayingVModel.value && currentAudioRef.value.paused) {
                currentAudioRef.value.play();
            }
        };
        const playFrom = (time) => {
            const prevAudioSegment = currentAudioSegment.value;
            currentTimeRef.value = time;
            if (currentAudioSegment.value == prevAudioSegment)
                syncAudioRef();
        };
        const playSegment = (index) => {
            if (props.segmentRecordings[index]) {
                playFrom(props.segmentRecordings[index].offset);
            }
            else {
                isPlayingVModel.value = false;
                nextTick(() => {
                    currentTimeRef.value = 0;
                });
            }
        };
        const timeupdate = (a, index) => {
            if (index == currentAudioSegment.value) {
                displayTime.value = a.currentTime + currentOffset.value;
            }
        };
        watch(isPlayingVModel, async (n) => {
            if (n) {
                nextTick(() => {
                    wavehover.value = false;
                    currentAudioRef.value?.play();
                });
            }
            else {
                currentAudioRef.value?.pause();
            }
        });
        const duration = computed(() => props.segmentRecordings.reduce((d, s) => {
            console.log(s.duration);
            return d + s.duration;
        }, 0));
        const getDuration = (idx) => {
            return props.segmentRecordings[idx].duration;
        };
        const getPrevDuration = (idx) => {
            return props.segmentRecordings.filter((_s, i) => i < idx).reduce((d, s) => d + s.duration, 0);
        };
        const getWidth = (idx) => {
            if (!waveWidth.value)
                return "0px";
            const ratio = getDuration(idx) / duration.value;
            const val = Math.ceil(ratio * waveWidth.value) + "px";
            return val;
        };
        const getWidthOffset = (idx) => {
            if (!waveWidth.value)
                return "0px";
            const ratio = getPrevDuration(idx) / duration.value;
            const val = Math.floor(ratio * waveWidth.value) + "px";
            return val;
        };
        const getUrl = async (recording) => {
            const file = await recording.file.getFile();
            if (file.size > 0) {
                const blob = new Blob([file], {
                    type: props.mimeType
                });
                recording.url = window.URL.createObjectURL(blob);
            }
            else {
                recording.url = `/api/assets/media/${props.mediaId}/${recording.segment}?mimeType=${encodeURIComponent(props.mimeType)}`;
            }
        };
        const wavehover = ref(false);
        const wavehoverPointer = computed(() => (validDuration.value ? "pointer !important" : "default  !important"));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("figure", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.segmentRecordings, (segment, idx) => {
                    return _withDirectives((_openBlock(), _createElementBlock("video", {
                        key: segment.id,
                        ref_for: true,
                        ref_key: "audioRefs",
                        ref: audioRefs,
                        class: "rec-media-player__video",
                        src: segment.url,
                        playsinline: ""
                    }, null, 8, _hoisted_2)), [
                        [_vShow, idx == currentAudioSegment.value && __props.type !== _unref(MediaSource).Audio]
                    ]);
                }), 128)),
                _createElementVNode("div", {
                    ref_key: "waveform",
                    ref: waveform,
                    class: "rec-media-player__audio",
                    onClick: waveClick,
                    onMouseover: _cache[0] || (_cache[0] = ($event) => (wavehover.value = true)),
                    onMouseleave: _cache[1] || (_cache[1] = ($event) => (wavehover.value = false))
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recordings.value, (segment, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: segment.id,
                            ref_for: true,
                            ref_key: "waveRefs",
                            ref: waveRefs,
                            class: "rec-media-player__audio__segment",
                            src: segment.url,
                            style: _normalizeStyle('width:' + getWidth(idx) + ';left:' + getWidthOffset(idx))
                        }, null, 12, _hoisted_3));
                    }), 128)),
                    _createVNode(_Transition, { name: "wavehover" }, {
                        default: _withCtx(() => [
                            (validDuration.value && wavehover.value && !__props.mobile && mousePosX.value > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "rec-media-player__audio__cursor" }, null, -1)),
                                    _createElementVNode("span", _hoisted_5, _toDisplayString(displayTimeFormatted.value), 1),
                                    _createElementVNode("span", _hoisted_6, _toDisplayString(waveMouseTimeFormatted.value), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    })
                ], 544)
            ]));
        };
    }
});
